module.exports = __webpack_public_path__ + "img/icon-coins-usa.ef76a1ad.svg";